(() => {
  if (window.__HausielCartUxFixInstalled) return;
  window.__HausielCartUxFixInstalled = true;

  const getRoot = () => window.Shopify?.routes?.root || '/';
  const ORDER_MAX = 10;

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawerElement = customElements.get('cart-drawer');
    const proto = CartDrawerElement?.prototype;
    if (!proto || proto.__hausielCartUxPatched) return;
    proto.__hausielCartUxPatched = true;

    const baseEnsure = proto.ensureHausielEnhancements;
    proto.ensureHausielEnhancements = function () {
      baseEnsure?.call(this);

      const footer = this.querySelector('.drawer__footer');
      const ctas = footer?.querySelector('#CartDrawer-Checkout')?.closest('.cart__ctas');
      if (!ctas || footer.querySelector('[data-hausiel-view-cart]')) return;

      const link = document.createElement('a');
      link.href = window.routes?.cart_url || `${getRoot()}cart`;
      link.className = 'hausiel-view-cart-link';
      link.setAttribute('data-hausiel-view-cart', '');
      link.textContent = 'Sepeti görüntüle ve düzenle';

      const assurance = footer.querySelector('.hausiel-drawer-assurance');
      if (assurance) assurance.insertAdjacentElement('beforebegin', link);
      else ctas.insertAdjacentElement('afterend', link);

      if (!document.getElementById('HausielCartUxFixStyles')) {
        const style = document.createElement('style');
        style.id = 'HausielCartUxFixStyles';
        style.textContent = '.hausiel-view-cart-link{display:block;margin:.8rem 0 0;text-align:center;color:inherit;text-decoration:underline;text-underline-offset:.22rem;font-size:1rem}.hausiel-view-cart-link:hover{text-decoration-thickness:.12rem}';
        document.head.appendChild(style);
      }
    };
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-hausiel-together] [data-hausiel-pair-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled) return;
    const root = button.closest('[data-hausiel-together]');
    const productInfo = document.querySelector(`product-info[data-product-id="${root?.dataset.productId || ''}"]`);
    const currentVariantInput =
      productInfo?.querySelector('product-form form input[name="id"]') ||
      productInfo?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      productInfo?.querySelector('form[action*="/cart/add"] input[name="id"]');
    const currentVariantId = String(currentVariantInput?.value || '');
    const pairedVariantId = String(button.dataset.variantId || '');
    const errorBox = button.parentElement?.querySelector('[data-hausiel-pair-error]');
    const singleAdd = button.hasAttribute('data-hausiel-single-add');

    if ((!singleAdd && !currentVariantId) || !pairedVariantId) {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = 'Lütfen ürün seçeneğini kontrol edip tekrar deneyin.';
      }
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Ekleniyor…';
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    try {
      const currentProductId = String(root?.dataset.productId || productInfo?.dataset.productId || '');
      const limitApi = window.HausielOrderLimit;
      let limitCart = null;
      if (limitApi && currentProductId && !singleAdd) {
        const gate = await limitApi.canAdd(currentProductId, 1, ORDER_MAX);
        limitCart = gate.cart;
        if (!gate.allowed) {
          throw new Error(`Bu üründen sipariş başına en fazla ${ORDER_MAX} adet ekleyebilirsiniz.`);
        }
      }

      if (limitApi && limitCart?.items) {
        const pairedExistingLine = limitCart.items.find((item) =>
          String(item?.variant_id || item?.id || '') === pairedVariantId
        );
        if (pairedExistingLine) {
          const pairedProductId = String(pairedExistingLine.product_id || '');
          const already = limitApi.quantityForProduct(limitCart, pairedProductId);
          const extraForPairedProduct = !singleAdd && pairedProductId === currentProductId ? 2 : 1;
          if (already + extraForPairedProduct > ORDER_MAX) {
            throw new Error(`Birlikte Al seçimindeki ürünlerden biri ${ORDER_MAX} adet sipariş sınırını aşıyor.`);
          }
        }
      }

      const cart = document.querySelector('cart-drawer');
      const payload = {
        items: singleAdd
          ? [{ id: Number(pairedVariantId), quantity: 1 }]
          : [
              { id: Number(currentVariantId), quantity: 1 },
              { id: Number(pairedVariantId), quantity: 1 },
            ],
      };

      if (cart) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(button);
      }

      const response = await fetch(window.routes?.cart_add_url || `${getRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Ürünler sepete eklenemedi.');
      }

      if (cart && data.sections) {
        cart.renderContents(data);
        requestAnimationFrame(() => cart.scheduleHausielUpdate?.());
      } else {
        window.location.assign(window.routes?.cart_url || `${getRoot()}cart`);
        return;
      }

      button.textContent = singleAdd ? 'Sepete eklendi' : 'İkisi sepete eklendi';
      setTimeout(() => {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }, 1800);
    } catch (error) {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = error?.message || 'Ürünler sepete eklenemedi. Lütfen tekrar deneyin.';
      }
      button.disabled = false;
      button.textContent = 'Tekrar deneyin';
      setTimeout(() => {
        if (button.isConnected) button.textContent = originalText;
      }, 1800);
    }
  }, true);
})();


(() => {
  if (window.__HausielCtaSafeFixInstalled) return;
  window.__HausielCtaSafeFixInstalled = true;

  const cartUrl = () => window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;

  const installStyles = () => {
    if (document.getElementById('HausielCtaSafeFixStyles')) return;
    const style = document.createElement('style');
    style.id = 'HausielCtaSafeFixStyles';
    style.textContent = `
      #HausielCookieBanner.hausiel-consent {
        left: 2rem !important;
        right: auto !important;
        top: auto !important;
        bottom: 2rem !important;
        width: min(720px, calc(100vw - 4rem)) !important;
        max-width: 720px !important;
        margin: 0 !important;
        grid-template-columns: minmax(0, 1.45fr) minmax(220px, .8fr) !important;
        gap: 14px !important;
        padding: 14px !important;
      }
      body:has(cart-drawer.active) #HausielCookieBanner {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
      cart-drawer .drawer__heading {
        cursor: pointer;
      }
      cart-drawer .drawer__heading:hover,
      cart-drawer .drawer__heading:focus-visible {
        text-decoration: underline;
        text-underline-offset: .22rem;
      }
      @media (max-width: 749px) {
        #HausielCookieBanner.hausiel-consent {
          left: 10px !important;
          right: 10px !important;
          top: max(10px, env(safe-area-inset-top)) !important;
          bottom: auto !important;
          width: auto !important;
          max-width: none !important;
          max-height: min(42dvh, 360px) !important;
          overflow-y: auto !important;
          grid-template-columns: 1fr !important;
          gap: 10px !important;
          padding: 12px !important;
        }
        #HausielCookieBanner .hausiel-consent__copy p {
          font-size: 13px !important;
          line-height: 1.35 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const decorateHeading = () => {
    const heading = document.querySelector('cart-drawer .drawer__heading');
    if (!heading || heading.dataset.hausielCartLink === 'true') return;
    heading.dataset.hausielCartLink = 'true';
    heading.setAttribute('role', 'link');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-label', 'Sepet sayfasına git');
  };

  document.addEventListener('click', (event) => {
    const heading = event.target.closest('cart-drawer .drawer__heading');
    if (!heading) return;
    window.location.assign(cartUrl());
  });

  document.addEventListener('keydown', (event) => {
    const heading = event.target.closest?.('cart-drawer .drawer__heading');
    if (!heading || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    window.location.assign(cartUrl());
  });

  installStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateHeading, { once: true });
  } else {
    decorateHeading();
  }
  customElements.whenDefined('cart-drawer').then(() => {
    decorateHeading();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(decorateHeading).observe(drawer, { childList: true, subtree: true });
  });
})();
